import React from 'react';

const Crown = ({color = '#1976d2', width = 20, height = 20}) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 100 100" width={width}
             height={height}>
            <g>
                <path
                    d="M73.053 74.804H25.509c-2.235 0-4.063 1.12-4.063 2.489s1.828 2.489 4.063 2.489h47.544c2.235 0 4.063-1.12 4.063-2.489s-1.829-2.489-4.063-2.489z"
                    fill={color}/>
                <path
                    d="M86.365 33.705l-13.545 3.98c-1.901.559-3.363 2.635-3.248 4.613l.407 6.998a3.368 3.368 0 0 1-3.394 3.597h-5.307c-1.982 0-3.162-1.56-2.624-3.467L61 41.115c.539-1.907.118-4.842-.935-6.52l-8.223-13.117c-1.053-1.679-2.773-1.678-3.823.003l-8.19 13.11c-1.05 1.681-1.47 4.617-.933 6.525l2.338 8.309c.537 1.908-.646 3.469-2.628 3.469h-5.261a3.37 3.37 0 0 1-3.395-3.597l.406-6.998c.115-1.979-1.347-4.056-3.248-4.617l-13.473-3.974c-1.901-.561-2.965.526-2.364 2.415l10.29 32.355c.601 1.888 2.713 3.434 4.695 3.434H73.7c1.982 0 4.096-1.545 4.698-3.432l10.328-32.357c.603-1.889-.46-2.976-2.361-2.418zM34.207 67.689a3.663 3.663 0 1 1 0-7.326 3.663 3.663 0 0 1 0 7.326zm15.794-.955l-5.765-5.766 5.765-5.765 5.766 5.766-5.766 5.765zm15.795.835a3.543 3.543 0 1 1 0-7.085 3.543 3.543 0 0 1 0 7.085z"
                    fill={color}/>
            </g>
        </svg>
    );
}

export default Crown;